module.exports = __webpack_public_path__ + "img/img2.cfadb070.png";